import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { NEW_PLANS, PRICING_FOOTNOTE } from "../../config/tripPlans";

function PricingCard({ plan }) {
  return (
    <div
      className={`relative flex flex-col ${plan.popular ? "border-2 border-[#C17F59]" : "border border-[#DCD4C6]"}`}
      style={{ background: "#F9F6F0", borderRadius: "2px" }}
      data-testid={`plan-card-${plan.key}`}
    >
      {plan.popular && (
        <div
          className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#C17F59] text-[#F9F6F0] text-xs px-4 py-1 whitespace-nowrap"
          style={{ fontFamily: "'Lora', Georgia, serif", borderRadius: "2px", letterSpacing: "0.05em" }}
          data-testid={`plan-badge-${plan.key}`}
        >
          Le plus choisi
        </div>
      )}
      <div className="p-6 flex-1 flex flex-col">
        <div className="mb-4">
          <h3 className="text-2xl mb-1" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}>
            {plan.name}
          </h3>
          <p className="text-xs text-[#9A8F86] italic" style={{ fontFamily: "'Lora', Georgia, serif" }}>{plan.desc}</p>
        </div>
        <div className="mb-6">
          <span className="text-5xl" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#C17F59" }} data-testid={`plan-price-${plan.key}`}>
            {plan.priceLabel}
          </span>
          <span className="text-xs text-[#9A8F86] ml-2 italic" style={{ fontFamily: "'Lora', Georgia, serif" }}>{plan.unit}</span>
          {plan.note && <p className="text-xs text-[#9A8F86] italic mt-1" style={{ fontFamily: "'Lora', Georgia, serif" }}>{plan.note}</p>}
        </div>
        <ul className="space-y-2.5 flex-1 mb-6">
          {plan.features.map((f, i) => (
            <li key={i} className="flex items-start gap-2.5 text-sm text-[#5C554E]" style={{ fontFamily: "'Lora', Georgia, serif" }}>
              <Check size={13} className="text-[#C17F59] mt-0.5 flex-shrink-0" strokeWidth={2.5} />
              {f}
            </li>
          ))}
        </ul>
        <Link
          to="/register"
          className={plan.popular ? "btn-primary text-center text-sm w-full" : "btn-secondary text-center text-sm w-full"}
          data-testid={`plan-cta-${plan.key}`}
        >
          Choisir cette offre
        </Link>
      </div>
    </div>
  );
}

export default function LandingPricing() {
  return (
    <section className="py-20 border-y border-[#DCD4C6]" style={{ background: "#F1EBE1" }}>
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-14">
          <p className="section-label mb-4">Nos offres</p>
          <h2
            className="text-4xl sm:text-5xl mb-4"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}
          >
            Choisissez votre niveau d'accompagnement
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-stretch max-w-3xl mx-auto">
          {NEW_PLANS.map((plan) => <PricingCard key={plan.key} plan={plan} />)}
        </div>

        <p className="text-sm text-center text-[#5C554E] mt-8 italic max-w-xl mx-auto" style={{ fontFamily: "'Lora', Georgia, serif" }} data-testid="pricing-footnote">
          {PRICING_FOOTNOTE}
        </p>
        <p className="text-xs text-[#9A8F86] mt-4 text-center italic" style={{ fontFamily: "'Lora', Georgia, serif" }}>
          La création de votre dossier voyage est gratuite. Vous choisissez votre offre uniquement après ma validation.
        </p>
      </div>
    </section>
  );
}
